export default "__VITE_ASSET__DT69qYE2__"